import { CountConfigurationResultDto } from 'lib_api/lib/api/gen';

import { DashboardConfigurationFilter } from '../types';

export function buildSearchFilterForParsingError(
  filter: Partial<DashboardConfigurationFilter>,
): DashboardConfigurationFilter {
  return {
    ...filter,
    hasError: true,
  };
}

export function libelleParsingError(
  count?: CountConfigurationResultDto,
): string | undefined {
  const total = count?.total ?? 0;

  return total ? `dont ${total} en erreur` : undefined;
}
